/**
 * Add sidebar triggers for AM Notes, Restricted nav items, etc.
 *
 * */

const bindSidebarTrigger = (trigger) => {
  trigger.addEventListener('click', () => {
    window.openSidebarLoader();

    setTimeout(() => {
      window.openSidebar(
        decodeURI(trigger.getAttribute('data-heading')),
        decodeURI(trigger.getAttribute('data-content')),
      );
    }, 200);
  });
};

if (document.querySelector('.sidebar-trigger')) {
  document.querySelectorAll('.sidebar-trigger').forEach((trigger) => {
    bindSidebarTrigger(trigger);

    // For AM Notes inside navbar items, page menus etc.
    // i.e. AM Notes inside anchor tags,
    // prevent page redirect on clicking the AM Notes icon
    if (
      trigger.closest('a')
      && (trigger.closest('a').classList.contains('navbar-item')
        || trigger.closest('a').classList.contains('button'))
    ) {
      trigger.closest('a').addEventListener('click', (event) => {
        if (event.target.localName !== 'a' && event.target.localName !== 'span') {
          event.preventDefault();
        }
      });
    }
  });

  // For AM Notes inside navbar items, prevent page redirect on clicking the AM Notes icon
  // if (document.querySelector('.navbar')) {
  //   document.querySelectorAll('.navbar-item').forEach((a) => {
  //     a.addEventListener('click', (event) => {
  //       if (event.target.localName !== 'a' && event.target.localName !== 'span') {
  //         event.preventDefault();
  //       }
  //     });
  //   });
  // }
}
